(function () {
  const header = document.querySelector('[data-adawat-header]');
  if (!header) return;

  function setupUtilityMarquee() {
    const viewport = header.querySelector('[data-adawat-marquee]');
    const track = viewport?.querySelector('[data-adawat-marquee-track]');
    const baseSet = track?.querySelector('[data-adawat-marquee-set]');
    if (!viewport || !track || !baseSet) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    while (track.children.length > 1) {
      track.removeChild(track.lastElementChild);
    }

    if (reduceMotion) {
      track.style.removeProperty('--ah-marquee-shift');
      return;
    }

    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    const setWidth = baseSet.getBoundingClientRect().width;
    if (!setWidth) return;

    const viewportWidth = viewport.getBoundingClientRect().width || window.innerWidth || 0;
    // Cover the viewport plus one extra set so the loop never shows empty yellow.
    const setsNeeded = Math.max(2, Math.ceil(viewportWidth / setWidth) + 2);

    for (let i = 1; i < setsNeeded; i += 1) {
      const clone = baseSet.cloneNode(true);
      clone.removeAttribute('data-adawat-marquee-set');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      track.appendChild(clone);
    }

    track.style.setProperty('--ah-marquee-shift', `${setWidth + gap}px`);
  }

  setupUtilityMarquee();
  let marqueeResizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(marqueeResizeTimer);
    marqueeResizeTimer = setTimeout(setupUtilityMarquee, 150);
  });

  const searchToggle = header.querySelector('[data-adawat-search-toggle]');
  const searchWrap = header.querySelector('[data-adawat-search-wrap]');
  const drawer = document.querySelector('[data-adawat-drawer]');
  // Escape #header-group transform/will-change containing block so fixed menu covers the viewport
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }
  const drawerOpenBtns = header.querySelectorAll('[data-adawat-drawer-open]');
  const drawerCloseBtns = document.querySelectorAll('[data-adawat-drawer-close]');

  searchToggle?.addEventListener('click', () => {
    searchWrap?.classList.toggle('is-open');
    searchWrap?.querySelector('input')?.focus();
  });

  const searchForm = header.querySelector('[data-adawat-search-form]');
  const searchCats = header.querySelector('[data-search-cats]');
  const searchCatsToggle = header.querySelector('[data-search-cats-toggle]');
  const searchCatsPanel = header.querySelector('[data-search-cats-panel]');
  const searchCatsLabel = header.querySelector('[data-search-cats-label]');
  const searchCatButtons = header.querySelectorAll('[data-search-cat]');
  const searchInput = searchForm?.querySelector('[data-search-input]');
  const suggestBox = searchForm?.querySelector('[data-search-suggest]');
  const suggestList = searchForm?.querySelector('[data-search-suggest-list]');
  const suggestAll = searchForm?.querySelector('[data-search-suggest-all]');
  const defaultSearchAction = searchForm?.dataset.defaultAction || '/search';
  const collectionsBase = searchForm?.dataset.collectionsBase || '/collections';
  const predictiveUrl = searchForm?.dataset.predictiveUrl || '/search/suggest.json';
  let selectedCollectionHandle = '';
  let suggestTimer = null;
  let suggestAbort = null;
  let suggestActiveIndex = -1;

  function closeSearchCats() {
    if (!searchCats) return;
    searchCats.classList.remove('is-open');
    searchCatsToggle?.setAttribute('aria-expanded', 'false');
    searchCatsToggle?.classList.toggle('is-pill', !!selectedCollectionHandle);
    searchCatsPanel?.setAttribute('hidden', '');
  }

  function openSearchCats() {
    if (!searchCats) return;
    closeSuggest();
    searchCats.classList.add('is-open');
    searchCatsToggle?.setAttribute('aria-expanded', 'true');
    searchCatsToggle?.classList.add('is-pill');
    searchCatsPanel?.removeAttribute('hidden');
  }

  function closeSuggest() {
    if (!suggestBox) return;
    suggestBox.setAttribute('hidden', '');
    searchInput?.setAttribute('aria-expanded', 'false');
    suggestActiveIndex = -1;
    if (suggestAbort) {
      suggestAbort.abort();
      suggestAbort = null;
    }
  }

  function openSuggest() {
    if (!suggestBox) return;
    closeSearchCats();
    suggestBox.removeAttribute('hidden');
    searchInput?.setAttribute('aria-expanded', 'true');
  }

  function formatMoney(amount) {
    if (amount == null || amount === '') return '';
    const raw = String(amount).trim();
    let num = Number(raw);
    if (!Number.isFinite(num)) return '';
    // Predictive search usually returns decimal currency strings ("80.00").
    // If we get an integer that looks like cents, convert it.
    if (/^\d+$/.test(raw) && num >= 1000) {
      num = num / 100;
    }
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.__ADAWAT_CURRENCY__ || window.Shopify?.currency?.active || 'USD',
      }).format(num);
    } catch (_) {
      return `$${num.toFixed(2)}`;
    }
  }

  function productImageUrl(product) {
    const img = product.image || product.featured_image;
    if (!img) return '';
    const raw = typeof img === 'string' ? img : img.url || img.src || '';
    if (!raw) return '';
    return raw.includes('?') ? `${raw}&width=88` : `${raw}?width=88`;
  }

  function rankSuggestProducts(products, query) {
    const q = String(query || '')
      .trim()
      .toLowerCase();
    const list = Array.isArray(products) ? products.slice() : [];

    const scored = list
      .map((product, index) => {
        const title = String(product.title || '').toLowerCase();
        const handle = String(product.handle || '').toLowerCase();
        const vendor = String(product.vendor || '').toLowerCase();
        const type = String(product.type || '').toLowerCase();
        const tags = (Array.isArray(product.tags) ? product.tags : []).join(' ').toLowerCase();
        let score = 0;
        if (title.startsWith(q)) score += 100;
        if (title.includes(q)) score += 60;
        if (handle.includes(q)) score += 40;
        if (vendor.includes(q)) score += 20;
        if (type.includes(q)) score += 20;
        if (tags.includes(q)) score += 10;
        return { product, score, index };
      })
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score || a.index - b.index)
      .map((entry) => entry.product);

    // Prefer real matches; if Shopify returned only weak related items, keep none
    // so the empty state is honest — then try the search.json fallback.
    return scored;
  }

  function setActiveSuggest(index) {
    const links = suggestList?.querySelectorAll('[data-suggest-link]');
    if (!links?.length) return;
    suggestActiveIndex = ((index % links.length) + links.length) % links.length;
    links.forEach((link, i) => {
      link.classList.toggle('is-active', i === suggestActiveIndex);
    });
  }

  function renderSuggest(products, query) {
    if (!suggestList || !suggestBox) return;

    if (!products.length) {
      suggestList.innerHTML = `<li class="adawat-header__suggest-empty">No products found for “${escapeHtml(
        query
      )}”</li>`;
      if (suggestAll) {
        suggestAll.hidden = true;
      }
      openSuggest();
      return;
    }

    suggestList.innerHTML = products
      .slice(0, 5)
      .map((product, i) => {
        const title = escapeHtml(product.title || '');
        const url = escapeHtml(product.url || '#');
        const img = productImageUrl(product);
        const price = formatMoney(product.price);
        const thumb = img
          ? `<span class="adawat-header__suggest-thumb"><img src="${escapeHtml(img)}" alt="" width="44" height="44" loading="lazy"></span>`
          : `<span class="adawat-header__suggest-thumb" aria-hidden="true"></span>`;
        return `
          <li class="adawat-header__suggest-item" role="option">
            <a class="adawat-header__suggest-link" href="${url}" data-suggest-link data-index="${i}">
              ${thumb}
              <span class="adawat-header__suggest-meta">
                <span class="adawat-header__suggest-title">${title}</span>
                ${price ? `<span class="adawat-header__suggest-price">${escapeHtml(price)}</span>` : ''}
              </span>
            </a>
          </li>`;
      })
      .join('');

    if (suggestAll) {
      const params = new URLSearchParams({ q: query, type: 'product' });
      suggestAll.href = `${defaultSearchAction}?${params.toString()}`;
      suggestAll.hidden = false;
    }

    suggestActiveIndex = -1;
    openSuggest();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  async function fetchSuggest(query) {
    if (!query || query.length < 2) {
      closeSuggest();
      return;
    }

    if (suggestAbort) suggestAbort.abort();
    suggestAbort = new AbortController();

    const buildParams = (limit, fields) =>
      new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': String(limit),
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': fields,
      });

    try {
      const res = await fetch(`${predictiveUrl}?${buildParams(10, 'title,product_type,vendor,variants.title,tag').toString()}`, {
        signal: suggestAbort.signal,
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('Suggest failed');
      const data = await res.json();
      let products = rankSuggestProducts(data?.resources?.results?.products || [], query);

      if (!products.length) {
        const fallbackRes = await fetch(
          `${predictiveUrl}?${buildParams(10, 'title,body,product_type,vendor,variants.title,tag').toString()}`,
          {
            signal: suggestAbort.signal,
            headers: { Accept: 'application/json' },
          }
        );
        if (fallbackRes.ok) {
          const fallbackData = await fallbackRes.json();
          products = rankSuggestProducts(fallbackData?.resources?.results?.products || [], query);
        }
      }

      renderSuggest(products, query);
    } catch (err) {
      if (err?.name === 'AbortError') return;
      closeSuggest();
    }
  }

  function scheduleSuggest() {
    const query = (searchInput?.value || '').trim();
    clearTimeout(suggestTimer);
    if (query.length < 2) {
      closeSuggest();
      return;
    }
    suggestTimer = setTimeout(() => fetchSuggest(query), 220);
  }

  searchInput?.addEventListener('input', scheduleSuggest);
  searchInput?.addEventListener('focus', () => {
    const query = (searchInput.value || '').trim();
    if (query.length >= 2 && suggestList?.children.length) openSuggest();
  });

  searchInput?.addEventListener('keydown', (e) => {
    if (suggestBox?.hasAttribute('hidden')) {
      if (e.key === 'ArrowDown' && (searchInput.value || '').trim().length >= 2) {
        scheduleSuggest();
      }
      return;
    }

    const links = suggestList?.querySelectorAll('[data-suggest-link]');
    if (!links?.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveSuggest(suggestActiveIndex + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveSuggest(suggestActiveIndex - 1);
    } else if (e.key === 'Enter' && suggestActiveIndex >= 0) {
      e.preventDefault();
      links[suggestActiveIndex]?.click();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      closeSuggest();
    }
  });

  function setSearchCatsLabel(title) {
    if (!searchCatsLabel) return;
    const full = searchCatsLabel.dataset.labelFull || 'All Categories';
    const short = searchCatsLabel.dataset.labelShort || 'All';
    const isAll = !title || title === full || title === short;
    if (isAll) {
      searchCatsLabel.innerHTML =
        `<span class="adawat-header__cats-label-full">${full}</span>` +
        `<span class="adawat-header__cats-label-short" aria-hidden="true">${short}</span>`;
      return;
    }
    searchCatsLabel.textContent = title;
  }

  function updateSearchScope(handle, title) {
    selectedCollectionHandle = handle || '';
    setSearchCatsLabel(title);
    searchCatButtons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.handle === selectedCollectionHandle);
    });
    if (selectedCollectionHandle) {
      searchCats?.classList.add('is-selected');
      searchCatsToggle?.classList.add('is-pill');
      searchForm.action = `${collectionsBase}/${selectedCollectionHandle}`;
    } else {
      searchCats?.classList.remove('is-selected');
      if (!searchCats?.classList.contains('is-open')) {
        searchCatsToggle?.classList.remove('is-pill');
      }
      searchForm.action = defaultSearchAction;
    }
  }

  searchCatsToggle?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (searchCats?.classList.contains('is-open')) {
      closeSearchCats();
    } else {
      openSearchCats();
    }
  });

  searchCatButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      updateSearchScope(btn.dataset.handle || '', btn.dataset.title || btn.textContent.trim());
      closeSearchCats();
      searchForm?.querySelector('[data-search-input]')?.focus();
    });
  });

  searchForm?.addEventListener('submit', (e) => {
    const input = searchForm.querySelector('[data-search-input]');
    const query = (input?.value || '').trim();

    if (selectedCollectionHandle) {
      searchForm.action = `${collectionsBase}/${selectedCollectionHandle}`;
      // Collection search uses ?q= — drop type=product (collections don't use it)
      const typeInput = searchForm.querySelector('[data-search-type]');
      const prefixInput = searchForm.querySelector('[name="options[prefix]"]');
      if (typeInput) typeInput.disabled = true;
      if (prefixInput) prefixInput.disabled = true;
      if (!query) {
        e.preventDefault();
        window.location.href = searchForm.action;
      }
    } else {
      searchForm.action = defaultSearchAction;
      const typeInput = searchForm.querySelector('[data-search-type]');
      const prefixInput = searchForm.querySelector('[name="options[prefix]"]');
      if (typeInput) typeInput.disabled = false;
      if (prefixInput) prefixInput.disabled = false;
    }
  });

  document.addEventListener('click', (e) => {
    if (!searchCats?.contains(e.target)) closeSearchCats();
    if (!searchForm?.contains(e.target)) closeSuggest();
  });

  let mobileNavBusy = false;

  function getMobileScreens() {
    return drawer ? Array.from(drawer.querySelectorAll('[data-mobile-screen]')) : [];
  }

  function getActiveMobileScreen() {
    return drawer?.querySelector('[data-mobile-screen].is-active') || null;
  }

  function clearMobileScreenTransit(screen) {
    screen?.classList.remove('is-behind', 'is-exiting-forward');
  }

  /** direction: 'forward' (drill in) | 'back' | 'instant' */
  function showMobileScreen(handle, direction = 'instant') {
    if (!drawer) return;
    const screens = getMobileScreens();
    const next = screens.find((s) => s.dataset.mobileScreen === handle);
    if (!next) return;

    const current = getActiveMobileScreen();
    if (current === next && direction === 'instant') {
      screens.forEach((screen) => {
        const active = screen === next;
        screen.classList.toggle('is-active', active);
        clearMobileScreenTransit(screen);
        screen.toggleAttribute('hidden', !active);
        screen.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      return;
    }

    if (direction === 'instant' || !current || current === next) {
      screens.forEach((screen) => {
        const active = screen === next;
        screen.classList.toggle('is-active', active);
        clearMobileScreenTransit(screen);
        screen.hidden = !active;
        screen.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      next.scrollTop = 0;
      return;
    }

    if (mobileNavBusy) return;
    mobileNavBusy = true;

    if (direction === 'forward') {
      next.hidden = false;
      next.setAttribute('aria-hidden', 'false');
      clearMobileScreenTransit(next);
      next.classList.remove('is-active');
      // Paint off-screen first, then slide forward
      requestAnimationFrame(() => {
        void next.offsetWidth;
        requestAnimationFrame(() => {
          current.classList.remove('is-active');
          current.classList.add('is-behind');
          current.setAttribute('aria-hidden', 'true');
          next.classList.add('is-active');
          next.scrollTop = 0;
        });
      });
    } else {
      // Back: current exits off the end edge; previous returns
      clearMobileScreenTransit(next);
      next.hidden = false;
      next.classList.add('is-behind');
      next.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        void next.offsetWidth;
        requestAnimationFrame(() => {
          current.classList.remove('is-active');
          current.classList.add('is-exiting-forward');
          next.classList.remove('is-behind');
          next.classList.add('is-active');
          next.scrollTop = 0;
        });
      });
    }

    const onDone = (event) => {
      if (event.target !== (direction === 'forward' ? next : current)) return;
      if (event.propertyName && event.propertyName !== 'transform') return;
      current.removeEventListener('transitionend', onDone);
      next.removeEventListener('transitionend', onDone);

      screens.forEach((screen) => {
        if (screen === next) {
          screen.classList.add('is-active');
          clearMobileScreenTransit(screen);
          screen.hidden = false;
          screen.setAttribute('aria-hidden', 'false');
        } else {
          screen.classList.remove('is-active');
          clearMobileScreenTransit(screen);
          screen.hidden = true;
          screen.setAttribute('aria-hidden', 'true');
        }
      });
      mobileNavBusy = false;
    };

    next.addEventListener('transitionend', onDone);
    current.addEventListener('transitionend', onDone);
    window.setTimeout(() => {
      if (!mobileNavBusy) return;
      onDone({ target: direction === 'forward' ? next : current, propertyName: 'transform' });
    }, 400);
  }

  function resetMobileMenu() {
    mobileNavBusy = false;
    showMobileScreen('root', 'instant');
    drawer?.querySelector('[data-mobile-menu-body]')?.scrollTo(0, 0);
  }

  function syncMenuToggle(open) {
    header.querySelectorAll('[data-adawat-drawer-open]').forEach((btn) => {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openDrawer() {
    resetMobileMenu();
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('adawat-drawer-open');
    syncMenuToggle(true);
  }

  function closeDrawer() {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('adawat-drawer-open');
    syncMenuToggle(false);
    window.setTimeout(() => resetMobileMenu(), 280);
  }

  drawerOpenBtns.forEach((btn) =>
    btn.addEventListener('click', () => {
      openDrawer();
    })
  );
  drawerCloseBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));
  drawer?.querySelector('[data-adawat-drawer-overlay]')?.addEventListener('click', closeDrawer);

  drawer?.querySelectorAll('[data-mobile-open-subs]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const handle = btn.dataset.mobileOpenSubs;
      const title = btn.dataset.mobileOpenTitle || btn.querySelector('.adawat-mobile-menu__row-label')?.textContent?.trim() || '';
      const screen = handle ? drawer.querySelector(`[data-mobile-screen="${handle}"]`) : null;
      if (screen && title) {
        const heading = screen.querySelector('[data-mobile-screen-title]');
        if (heading) heading.textContent = title;
        const shopAll = screen.querySelector('[data-mobile-shopall]');
        if (shopAll) {
          const prefix = document.documentElement.lang === 'ar' ? 'تسوق كل' : 'Shop all';
          shopAll.textContent = `${prefix} ${title}`;
        }
      }
      showMobileScreen(handle, 'forward');
    });
  });

  drawer?.querySelectorAll('[data-mobile-back]').forEach((btn) => {
    btn.addEventListener('click', () => {
      showMobileScreen('root', 'back');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
      closeMega();
      closeSearchCats();
      closeSuggest();
    }
  });

  const mega = header.querySelector('[data-adawat-mega]');
  const megaCats = mega?.querySelectorAll('[data-mega-cat]');
  const megaPanes = mega?.querySelectorAll('[data-mega-pane]');
  const megaTrigger = mega?.querySelector('[data-mega-trigger]');

  function openMega() {
    mega?.classList.add('is-open');
    megaTrigger?.setAttribute('aria-expanded', 'true');
    setHeaderMegaOpen(true);
    setHeaderScrollHidden(false);
    requestAnimationFrame(() => window.AdawatRefreshSale?.());
  }

  function closeMega() {
    mega?.classList.remove('is-open');
    megaTrigger?.setAttribute('aria-expanded', 'false');
    setHeaderMegaOpen(false);
  }

  function activateMegaCat(handle) {
    megaCats?.forEach((cat) => {
      cat.classList.toggle('is-active', cat.dataset.megaCat === handle);
    });
    megaPanes?.forEach((pane) => {
      const active = pane.dataset.megaPane === handle;
      pane.classList.toggle('is-active', active);
      pane.toggleAttribute('hidden', !active);
    });
    window.AdawatRefreshSale?.();
  }

  megaCats?.forEach((cat) => {
    cat.addEventListener('mouseenter', () => activateMegaCat(cat.dataset.megaCat));
    cat.addEventListener('focus', () => activateMegaCat(cat.dataset.megaCat));
  });

  mega?.querySelector('[data-mega-pane="10-picks"]')
    ?.querySelectorAll('.adawat-mega__product')
    .forEach((card) => {
      const dollars = Number(card.getAttribute('data-price-dollars') || '');
      if (Number.isFinite(dollars) && dollars > 10.0001) card.remove();
    });

  mega?.addEventListener('mouseenter', openMega);
  mega?.addEventListener('mouseleave', closeMega);
  megaTrigger?.addEventListener('focus', openMega);

  const sidebarScroll = mega?.querySelector('[data-mega-sidebar-scroll]');
  const sidebarUp = mega?.querySelector('[data-mega-sidebar-up]');
  const sidebarDown = mega?.querySelector('[data-mega-sidebar-down]');

  function updateSidebarArrows() {
    if (!sidebarScroll) return;
    const maxScroll = sidebarScroll.scrollHeight - sidebarScroll.clientHeight;
    const top = sidebarScroll.scrollTop;
    if (sidebarUp) sidebarUp.disabled = top <= 2;
    if (sidebarDown) sidebarDown.disabled = top >= maxScroll - 2 || maxScroll <= 2;
  }

  function scrollSidebar(direction) {
    if (!sidebarScroll) return;
    sidebarScroll.scrollBy({ top: direction * 160, behavior: 'smooth' });
  }

  sidebarUp?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    scrollSidebar(-1);
  });
  sidebarDown?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    scrollSidebar(1);
  });
  sidebarScroll?.addEventListener('scroll', updateSidebarArrows);
  mega?.addEventListener('mouseenter', () => {
    requestAnimationFrame(updateSidebarArrows);
  });
  window.addEventListener('resize', updateSidebarArrows);
  updateSidebarArrows();

  document.addEventListener('cart:update', updateCartCount);
  document.addEventListener('cart:add', updateCartCount);
  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const n = cart?.totalQuantity ?? detail?.itemCount ?? detail?.item_count;
        if (n != null) paintCartCount(n);
      })
      .catch(() => {});
  });

  function paintCartCount(count) {
    const n = Math.max(0, Number(count) || 0);
    document.querySelectorAll('[data-adawat-cart-count]').forEach((el) => {
      el.textContent = String(n);
      el.dataset.count = String(n);
    });
  }

  async function updateCartCount(event) {
    const fromEvent = event?.detail?.itemCount ?? event?.detail?.item_count;
    if (fromEvent != null && Number.isFinite(Number(fromEvent))) {
      paintCartCount(fromEvent);
      return;
    }
    try {
      const res = await fetch(`/cart.js?t=${Date.now()}`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      });
      const cart = await res.json();
      const items = Array.isArray(cart?.items) ? cart.items : [];
      const realCount = items.length
        ? items.reduce((sum, item) => {
            if (item?.properties?._adawat_sale_probe) return sum;
            return sum + (Number(item.quantity) || 0);
          }, 0)
        : Number(cart?.item_count || 0);
      paintCartCount(realCount);
    } catch (_) {}
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) updateCartCount();
  });

  const flicker = header.querySelector('[data-adawat-flicker]');
  const flickerItems = flicker?.querySelectorAll('[data-flicker-item]');
  if (flicker && flickerItems && flickerItems.length > 1) {
    let index = 0;
    const interval = Number(flicker.dataset.interval) || 3000;

    setInterval(() => {
      flickerItems[index].classList.remove('is-active');
      index = (index + 1) % flickerItems.length;
      flickerItems[index].classList.add('is-active');
    }, interval);
  }

  const headerGroup = document.getElementById('header-group');
  const pageWrapper = document.querySelector('.page-wrapper');
  const mobileMq = window.matchMedia('(max-width: 767px)');
  const pageScrollMq = window.matchMedia('(min-width: 990px)');

  function setHeaderScrollHidden() {
    // Header stays sticky sitewide — never hide the whole bar
    headerGroup?.classList.remove('is-scroll-hidden');
    header.classList.remove('is-scroll-hidden');
    document.documentElement.classList.remove('adawat-header-hidden');
  }

  function setUtilityCollapsed(collapsed) {
    const shouldCollapse = Boolean(collapsed) && mobileMq.matches;
    const isCollapsed = header.classList.contains('is-utility-collapsed');
    if (isCollapsed === shouldCollapse) return;
    header.classList.toggle('is-utility-collapsed', shouldCollapse);
    headerGroup?.classList.toggle('is-utility-collapsed', shouldCollapse);
  }

  function setNavCollapsed(collapsed) {
    const shouldCollapse = Boolean(collapsed) && !mobileMq.matches;
    const isCollapsed = header.classList.contains('is-nav-collapsed');
    if (isCollapsed === shouldCollapse) return;
    header.classList.toggle('is-nav-collapsed', shouldCollapse);
    headerGroup?.classList.toggle('is-nav-collapsed', shouldCollapse);
    if (shouldCollapse) {
      closeMega();
      setHeaderMegaOpen(false);
    }
  }

  function setHeaderMegaOpen(open) {
    headerGroup?.classList.toggle('is-mega-open', open);
    header.classList.toggle('is-mega-open', open);
    document.documentElement.classList.toggle('adawat-header-mega-open', open);
  }

  /* Sticky header always visible.
     Mobile: hide navy top bar on scroll down; show again on scroll up / top.
     Desktop: nav is moved after #header-group so it scrolls away; hamburger appears
     when the nav is no longer visible. Header height never changes — no shake. */
  function getScrollY() {
    if (pageScrollMq.matches && pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1) {
      return pageWrapper.scrollTop || 0;
    }
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  const navEl = header.querySelector('.adawat-header__nav');
  const navHome = navEl?.parentElement;

  function placeDesktopNav() {
    if (!navEl || !headerGroup) return;
    if (mobileMq.matches) {
      if (navHome && navEl.parentElement !== navHome) {
        navHome.appendChild(navEl);
      }
      setNavCollapsed(false);
      return;
    }
    if (navEl.parentElement !== headerGroup.parentElement) {
      headerGroup.after(navEl);
    }
  }

  function syncDesktopHamburger() {
    if (mobileMq.matches || !navEl || !headerGroup) {
      setNavCollapsed(false);
      return;
    }
    const headerBottom = headerGroup.getBoundingClientRect().bottom;
    const navBottom = navEl.getBoundingClientRect().bottom;
    setNavCollapsed(navBottom <= headerBottom + 2);
  }

  let utilityCollapsed = false;
  let scrollAnchorY = getScrollY();
  let ticking = false;
  let toggleCooldown = false;
  const hideAfter = 24;
  const collapseDistance = 56;
  const expandDistance = 20;
  const toggleCooldownMs = 320;

  function updateHeaderVisibility() {
    const y = getScrollY();
    const drawerOpen = document.body.classList.contains('adawat-drawer-open');
    const sotOpen = document.documentElement.classList.contains('adawat-sot-lock');
    const megaOpen = mega?.classList.contains('is-open');

    setHeaderScrollHidden();

    if (!mobileMq.matches) {
      syncDesktopHamburger();
      ticking = false;
      return;
    }

    if (drawerOpen || megaOpen || sotOpen || y <= hideAfter) {
      if (utilityCollapsed) setUtilityCollapsed(false);
      utilityCollapsed = false;
      scrollAnchorY = y;
      ticking = false;
      return;
    }

    if (toggleCooldown) {
      ticking = false;
      return;
    }

    const movedFromAnchor = y - scrollAnchorY;

    if (!utilityCollapsed && movedFromAnchor > collapseDistance) {
      setUtilityCollapsed(true);
      utilityCollapsed = true;
      scrollAnchorY = y;
      closeSearchCats();
      closeSuggest();
      toggleCooldown = true;
      window.setTimeout(() => {
        toggleCooldown = false;
      }, toggleCooldownMs);
    } else if (utilityCollapsed && movedFromAnchor < -expandDistance) {
      setUtilityCollapsed(false);
      utilityCollapsed = false;
      scrollAnchorY = y;
      toggleCooldown = true;
      window.setTimeout(() => {
        toggleCooldown = false;
      }, toggleCooldownMs);
    }

    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeaderVisibility);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  pageWrapper?.addEventListener('scroll', onScroll, { passive: true });
  mobileMq.addEventListener?.('change', () => {
    if (!mobileMq.matches) {
      setUtilityCollapsed(false);
      utilityCollapsed = false;
    }
    placeDesktopNav();
    scrollAnchorY = getScrollY();
    updateHeaderVisibility();
  });
  placeDesktopNav();
  updateHeaderVisibility();
})();
